import script from "./TurmaView.vue?vue&type=script&setup=true&lang=js"
export * from "./TurmaView.vue?vue&type=script&setup=true&lang=js"

import "./TurmaView.vue?vue&type=style&index=0&id=d2dee076&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2dee076"]])

export default __exports__